"use strict";

var _interopRequireDefault = require("/home/runner/work/ap-cn-sfe-fe-pc/ap-cn-sfe-fe-pc/app/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _classCallCheck2 = _interopRequireDefault(require("/home/runner/work/ap-cn-sfe-fe-pc/ap-cn-sfe-fe-pc/app/node_modules/@babel/runtime-corejs2/helpers/classCallCheck.js"));
var _createClass2 = _interopRequireDefault(require("/home/runner/work/ap-cn-sfe-fe-pc/ap-cn-sfe-fe-pc/app/node_modules/@babel/runtime-corejs2/helpers/createClass.js"));
var _callSuper2 = _interopRequireDefault(require("/home/runner/work/ap-cn-sfe-fe-pc/ap-cn-sfe-fe-pc/app/node_modules/@babel/runtime-corejs2/helpers/callSuper.js"));
var _inherits2 = _interopRequireDefault(require("/home/runner/work/ap-cn-sfe-fe-pc/ap-cn-sfe-fe-pc/app/node_modules/@babel/runtime-corejs2/helpers/inherits.js"));
var _plugin = _interopRequireDefault(require("@ckeditor/ckeditor5-core/src/plugin"));
var _command = _interopRequireDefault(require("./command.js"));
var _utils = require("@ckeditor/ckeditor5-widget/src/utils");
var _widget = _interopRequireDefault(require("@ckeditor/ckeditor5-widget/src/widget"));
// 插件类，需要基于这个扩展
// 在这个文件里面创建命令
var PdfEdit = exports.default = /*#__PURE__*/function (_Plugin) {
  function PdfEdit() {
    (0, _classCallCheck2.default)(this, PdfEdit);
    return (0, _callSuper2.default)(this, PdfEdit, arguments);
  }
  (0, _inherits2.default)(PdfEdit, _Plugin);
  return (0, _createClass2.default)(PdfEdit, [{
    key: "init",
    value: function init() {
      // 定义架构的方法  规定元素的属性，这个属性不是HTML的属性，是CKEditor内使用的
      this._defineSchema();

      // 定义转换器  转换器是生成HTML元素的地方  将定义的模型生成HTML结构
      this._defineConverters();

      // 绑定一个事件 block
      this.editor.commands.add('pdf', new _command.default(this.editor));
    }

    // 注册模型
  }, {
    key: "_defineSchema",
    value: function _defineSchema() {
      var schema = this.editor.model.schema;
      schema.register('pdfBox', {
        // 是否为一个完整的对象，不可被回车拆分，意思是回车等行为都是在它自身容器内进行
        isObject: true,
        // isBlock: true,
        // 要求字符串或数组字符串，可以从其他地方继承
        allowWhere: '$block',
        allowContentOf: '$root'
      });
      schema.register('pdfIcon', {
        isLimit: true,
        // 在哪个地方使用
        allowIn: 'pdfBox',
        // 设置改节点是块还是根，根可以回车
        allowContentOf: '$block'
      });
      schema.register('pdfTitle', {
        isLimit: true,
        allowIn: 'pdfBox',
        // allowAttributes: ['data-uuid'],
        // 设置改节点是块还是根，根可以回车, $root / $block
        allowContentOf: '$block'
      });
      schema.register('pdfUuBox', {
        isLimit: true,
        allowIn: 'pdfTitle',
        // allowAttributes: ['data-uuid'],
        // 设置改节点是块还是根，根可以回车, $root / $block
        allowContentOf: '$root'
      });
    }

    // 文档：https://ckeditor.com/docs/ckeditor5/latest/api/module_editor-classic_classiceditor-ClassicEditor.html#member-conversion
  }, {
    key: "_defineConverters",
    value: function _defineConverters() {
      var conversion = this.editor.conversion;
      // 定义转换器  pdfBox模型转换成视图  -> <div class="pdfBox"></div>
      // 使用editingDowncast数据管道
      // 创建一个元件
      // model的名称整个项目需要唯一
      // conversion.elementToElement({
      //   model: 'pdfBox',
      //   view: {
      //     name: 'div',
      //     classes: 'pdf-box'
      //   }
      // })

      conversion.elementToElement({
        model: 'pdfIcon',
        view: {
          name: 'div',
          classes: 'pdf-icon'
        }
      });
      conversion.elementToElement({
        model: 'pdfTitle',
        view: {
          name: 'div',
          classes: 'pdf-title'
        }
      });
      conversion.elementToElement({
        model: 'pdfUuBox',
        view: {
          name: 'div',
          classes: 'pdf-uu-box'
        }
      });
      conversion.for('upcast').elementToElement({
        model: 'pdfBox',
        view: {
          name: 'div',
          classes: 'pdf-box'
        }
      });
      conversion.for('dataDowncast').elementToElement({
        model: 'pdfBox',
        view: {
          name: 'div',
          classes: 'pdf-box'
        }
      });
      conversion.for('editingDowncast').elementToElement({
        model: 'pdfBox',
        view: function view(modelElement, _ref) {
          var viewWriter = _ref.writer;
          var div = viewWriter.createContainerElement('div', {
            class: 'pdf-box'
          });
          return (0, _utils.toWidget)(div, viewWriter, {
            label: 'simple box widget'
          });
        }
      });
    }
  }], [{
    key: "requires",
    get: function get() {
      // ADDED
      return [_widget.default];
    }
  }]);
}(_plugin.default);